// extracted by mini-css-extract-plugin
export default {"Toolbar":"Toolbar_Toolbar__wyFyE"};